/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Link,
  useLocation
  // useNavigate
} from 'react-router-dom';
import styled from 'styled-components';
import { Menu } from 'antd';
import {
  InsightsSignIcon,
  CustomReportSignIcon,
  TransactionSignIcon,
  PayoutSignIcon,
  SettingSignIcon,
  InvoicesSignIcon,
  MerchantsSignIcon
} from 'utils/icons';
import trackingService from 'services/trackingService';

// customised style of ant menu class using styled-components
const CustomMenu = styled(Menu)`
  background-color: #580d0d00;
  border-inline-end: none !important;
  font-size: 1rem;
  width: 100%;

  .ant-menu-item,
  .ant-menu-submenu-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-menu-item-selected {
    background-color: var(--color-primary) !important;
    color: #ffffff;

    .custom-icon svg path {
      fill: #ffffff;
    }
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: var(--color-primary);
    color: #ffffff;

    .custom-icon svg path {
      fill: #ffffff;
    }
  }

  /* Add this block for hover background */
  .ant-menu-item:hover:not(.ant-menu-item-selected),
  .ant-menu-submenu-title:hover:not(.ant-menu-submenu-selected > .ant-menu-submenu-title) {
    background-color: var(--color-fill-alter); !important; /* light purple */
  }

  .ant-menu-submenu-title:not(.ant-menu-submenu-selected > .ant-menu-submenu-title):hover {
    background-color: var(--color-fill-alter); !important;
  }

  .ant-menu-submenu-title:hover:not(.ant-menu-submenu-selected > .ant-menu-submenu-title) {
    .custom-icon svg path {
      fill: black;
    }
  }

  .ant-menu-submenu-selected .ant-menu-item-selected {
    background-color: #fdfdfd00 !important;
    color: var(--color-primary);

    .custom-icon svg path {
      fill: var(--color-primary);
    }
  }

  .custom-icon {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .custom-icon svg {
    width: 20px;
    height: 20px;
    display: block;
  }
`;

function EbzMenu() {
  const permissions = useSelector((state) => state.user.planPermissions);
  const location = useLocation();

  const [menuItems, setMenuItems] = useState(
    [
      permissions?.can_view_dashboard && {
        index: 1,
        key: '/dashboard',
        label: <Link to="/dashboard">Insights</Link>,
        icon: <InsightsSignIcon className="custom-icon" />
      },

      (permissions?.can_view_gtv_dashboard_report === false ||
        permissions?.can_view_gtv_dashboard_report ||
        permissions?.can_view_leads) && {
        index: 2,
        key: 'merchants',
        label: 'Merchants',
        icon: <MerchantsSignIcon className="custom-icon" />,
        children: [
          {
            key: '/referrals',
            label: <Link to="/referrals">Referral</Link>
          },
          permissions?.can_view_gtv_dashboard_report && {
            key: '/referrals/referral-gtv',
            label: <Link to="/referrals/referral-gtv">GTV Dashboard</Link>
          },
          permissions?.can_view_leads && {
            key: '/leads',
            label: <Link to="/leads">Leads</Link>
          }
        ].filter(Boolean)
      },

      permissions?.can_view_transactions && {
        index: 3,
        key: '/transactions',
        label: <Link to="/transactions">Transactions</Link>,
        icon: <TransactionSignIcon className="custom-icon" />
      },

      permissions?.can_view_custom_report && {
        index: 6,
        key: '/custom-reports',
        label: <Link to="/custom-reports">Custom Reports</Link>,
        icon: <CustomReportSignIcon className="custom-icon" />
      },

      permissions?.can_view_payout_report && {
        index: 7,
        key: '/payout-reports',
        label: <Link to="/payout-reports">Payout Reports</Link>,
        icon: <PayoutSignIcon className="custom-icon" />
      },

      permissions?.can_view_invoices && {
        index: 5,
        key: '/invoices',
        label: <Link to="/invoices">Invoices</Link>,
        icon: <InvoicesSignIcon className="custom-icon" />
      },

      {
        index: 8,
        key: '/settings',
        label: <Link to="/settings">Settings</Link>,
        icon: <SettingSignIcon className="custom-icon" />
      }
    ].filter(Boolean)
  );

  // redux state
  const user = useSelector((state) => state.user.currentUser);
  const configs = useSelector((state) => state.user.currentUser.configuration);
  //
  useEffect(() => {
    trackingService.trackPageView(location.pathname);
  }, [location]);
  // const navigate = useNavigate();

  // effects
  // useEffect(() => {
  //   if (configs !== undefined) {
  //     if (
  //       configs.permission_configs.can_view_payout_report ||
  //       configs.permission_configs.can_view_custom_report
  //     ) {
  //       const found = menuItems.some((el) => el.index === 4);
  //       if (!found) {
  //         setMenuItems((prevState) => [
  //           ...prevState,
  //           {
  //             index: 4,
  //             // key: '/reports',
  //             label: 'Reports',
  //             icon: <ReportsIcon className="custom-icon" />,
  //             children: [
  //               configs.permission_configs.can_view_payout_report && {
  //                 key: '/reports',
  //                 label: <Link to="/reports">Payout Reports</Link>,
  //                 icon: <DoubleRightOutlined className="custom-icon" />
  //               },
  //               // configs.permission_configs.can_view_custom_report && {
  //               //   key: '/reports/commission-reports',
  //               //   label: <Link to="/reports/commission-reports">Commission Reports</Link>,
  //               //   icon: <DoubleRightOutlined className="custom-icon" />
  //               // },
  //               configs.permission_configs.can_view_custom_report && {
  //                 key: '/reports/custom-reports',
  //                 label: <Link to="/reports/custom-reports">Custom Reports</Link>,
  //                 icon: <DoubleRightOutlined className="custom-icon" />
  //               }
  //               // ,
  //               // user?._id === 4486 &&
  //               //   configs.permission_configs.can_view_custom_report && {
  //               //     key: '/reports/custom-reports-new',
  //               //     label: <Link to="/reports/custom-reports-new">Custom Reports 2</Link>,
  //               //     icon: <DoubleRightOutlined className="custom-icon" />
  //               //   }
  //             ]
  //           }
  //         ]);
  //       }
  //     }
  //   }
  // }, [configs]);
  //

  return (
    <CustomMenu
      mode="inline"
      items={menuItems}
      defaultOpenKeys={[location.pathname]}
      defaultSelectedKeys={[location.pathname]}
    />
  );
}

export default EbzMenu;
